import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";

import "../addRow.css";
import "./addBalRwd.css";
import Inpt from "../../../components/crudSql/inpt/Inpt";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
import SetTitle from "../../../components/setTitle/SetTitle";

import Button from "@mui/material/Button";
import { ArrowDropDown, ArrowDropUp, AddBox } from "@mui/icons-material";

import VaultItem, {
  splitAndDivideStrings,
  splitAndMultiplyStrings,
} from "../../../components/crudSql/vaultItem/VaultItem";
import VaultItemNumerous from "../../../components/crudSql/vaultItem/VaultItemNumerous";
import HiddenBlock from "../../../components/crudSql/hiddenBlock/HiddenBlock";
import { getCurrentDatetime } from "../../../components/common/date";
import ClaimRewardsVaultItem from "../../../components/crudSql/vaultItem/ClaimRewardsVaultItem";
import { walletShortLast } from "../../../components/common/dataShort";

export default function AddBalRwd(props) {
  SetTitle("Add Current Balance and Rewards");

  // const [searchParams, setSearchParams] = useSearchParams();
  // searchParams.get("__fire"); // /?_fire=..

  const location = useLocation();
  const [assetId, setAssetId] = useState(0);
  const [vaultData, setVaultData] = useState([]);
  const [dataSaved, setDataSaved] = useState(false);

  const [id, setId] = useState("");
  const [walletByLocation, setWalletByLocation] = useState("");
  const [name, setName] = useState("");
  // const [blockchain, setBlockchain] = useState("");
  // const [platform, setPlatform] = useState("");
  // const [vault, setVault] = useState("");
  // const [uses, setUses] = useState("");
  const [inputs, setInputs] = useState({
    // blockchain: "",
    // platform: "",
    // vault: "",
    // uses: "",
    // assetId: 0,
    balanceOf: "",
    pricePerFullShare: "",
    balance: "",
    balanceUsd: "",
    rewardToken: "SBR",
    reward: "",
    rewardUsd: "",
    rewardTokensUsd: "",
    lpToken: "wUST-USDC",
    lpTokens: "",
    lpTokensUsd: "",
    totalUsd: "",
    borrow: "",
    borrowedUsd: "",
    borrowedUsd2: "",
    claimed: "",
    totalClaimed: "",
    totalClaimedUsd: "",
    apr: "",
    apy: "",
    tvl: "",
    remark: "",
    time: getCurrentDatetime(),
    wallet: "",
  });
  const [calcInputs, setCalcInputs] = useState({});

  // Изменяем value заданного инпута при вводе внутри этого поля
  function inputChange(evt) {
    //const value = evt.target.value;

    // console.log("inputChange->setInputs");
    setInputs((prevInputs) => {
      // рассчетный массив с данными для отсылки
      let calcInputs_ = {
        ...prevInputs,
        [evt.target.name]: evt.target.value,
      };

      calcInputs_ = {
        ...calcInputs_,

        ...(!calcInputs_.lpTokensUsd &&
          calcInputs_.balance &&
          calcInputs_.balanceUsd && {
            lpTokensUsd: splitAndDivideStrings(
              calcInputs_.balanceUsd,
              calcInputs_.balance
            ),
          }),

        ...(!calcInputs_.balanceUsd &&
          calcInputs_.balance &&
          calcInputs_.lpTokensUsd && {
            balanceUsd: splitAndMultiplyStrings(
              calcInputs_.balance,
              calcInputs_.lpTokensUsd
            ),
          }),

        ...(!calcInputs_.rewardTokensUsd &&
          calcInputs_.reward &&
          calcInputs_.rewardUsd && {
            rewardTokensUsd: splitAndDivideStrings(
              calcInputs_.rewardUsd,
              calcInputs_.reward
            ),
          }),

        ...(!calcInputs_.rewardUsd &&
          calcInputs_.reward &&
          calcInputs_.rewardTokensUsd && {
            rewardUsd: splitAndMultiplyStrings(
              calcInputs_.reward,
              calcInputs_.rewardTokensUsd
            ),
          }),

        ...(!calcInputs_.borrowedTokensUsd &&
          calcInputs_.borrowed &&
          calcInputs_.borrowedUsd && {
            borrowedTokensUsd: splitAndDivideStrings(
              calcInputs_.borrowedUsd,
              calcInputs_.borrowed
            ),
          }),

        ...(!calcInputs_.borrowedUsd &&
          calcInputs_.borrowed &&
          calcInputs_.borrowedTokensUsd && {
            borrowedUsd: splitAndMultiplyStrings(
              calcInputs_.borrowed,
              calcInputs_.borrowedTokensUsd
            ),
          }),
      };

      if (
        !calcInputs_.totalUsd &&
        calcInputs_.balanceUsd &&
        calcInputs_.rewardUsd
      )
        calcInputs_.totalUsd = +(
          +calcInputs_.balanceUsd + rewardsUsd(calcInputs_)
        ).toFixed(2);

      setCalcInputs(calcInputs_);

      // массив с данными для вывода (не совпадает с расчетным чтобы скрывались поля)
      return {
        ...prevInputs,
        [evt.target.name]: evt.target.value,
      };
    });
  }

  function getWalletByLocationAndSetWalletByLocation() {
    if (location) {
      const pathnameA = location.pathname.split("/");
      // console.log("split", pathnameA, pathnameA.length, pathnameA[4]);
      // if (pathnameA.length == 6) return pathnameA[4];
      if (pathnameA.length == 6) setWalletByLocation(pathnameA[4]);
    }
    // return "";
  }
  useEffect(() => {
    if (location) {
      // console.log("location", location);

      const assetId = location.pathname.slice(
        location.pathname.lastIndexOf("/") + 1,
        location.pathname.length
      );
      setAssetId(assetId);

      getWalletByLocationAndSetWalletByLocation();
    }
  }, [location]);

  useEffect(() => {
    const getVaultDataById = () => {
      const url =
        process.env.REACT_APP_CRUD_SRV +
        "/vault?assetId=" +
        assetId +
        "&auth=" +
        props.userAuthWallet +
        "&cs=" +
        sha256(props.userAuthWallet + process.env.REACT_APP_SECRET);
      if (process.env.REACT_APP_CLG_AXIOS_URLS == 1) console.log(url);
      Axios.get(
        url
        // bcrypt(userAuthWallet, process.env.REACT_APP_SECRET)
      ).then((res) => {
        // console.log("/vault? =", res.data.response);
        setVaultData(res.data.response);
        // console.log("assetId->setInputs");
        setInputs((prevInputs) => {
          return {
            ...prevInputs,
            lpToken: res.data.response[0].Vault,
            rewardToken: res.data.response[0].RewardAbbr,
          };
        });
        // console.log("dbg=", process.env.REACT_APP_IS_DBG, userAuthWallet, process.env.REACT_APP_SECRET);
        // if (process.env.REACT_APP_IS_DBG)
        //   console.log("useEffect.userWallets=", userWallets); // -- is not working - but works fine later outside useEffect
      });
    };

    if (assetId > 0) getVaultDataById();
  }, [assetId]);

  useEffect(() => {
    console.log("inputs =", inputs);
  }, [inputs]);
  useEffect(() => {
    console.log("calcInputs =", calcInputs);
  }, [calcInputs]);
  useEffect(() => {
    console.log("walletByLocation =", walletByLocation);
  }, [walletByLocation]);

  useEffect(() => {
    // prettier-ignore
    // console.log("props.userWallets =", props.userWallets, "walByLoc =", walletByLocation);

    if (
      walletByLocation
      // typeof props.userWallets[0]?.wallet !== "undefined" &&
      // inputs.wallet == ""
    ) {
      // console.log("userWallets->setInputs");
      setInputs((prevInputs) => {
        return {
          ...prevInputs,
          // wallet: props.userWallets[0].wallet,
          wallet: walletByLocation,
          // ? walletByLocation
          // : props.userWallets[0].wallet,
        };
      });
    }
    // }, [props.userWallets, walletByLocation]);
  }, [walletByLocation]);

  // Действие при нажатии на кнопку
  const saveInfo = () => {
    // if (inputs.name === "")
    //   setInputs((prevInputs) => {
    //     return { ...prevInputs, name: name };
    //   });

    console.log("save: inputs =", inputs);

    1 &&
      Axios.post(process.env.REACT_APP_CRUD_SRV + "/add/bal", {
        assetId,
        // ...inputs,
        // rewardUsd: rewardsUsd(),
        // ...(!inputs.lpTokensUsd &&
        //   inputs.balance &&
        //   inputs.balanceUsd && {
        //     lpTokensUsd: splitAndDivideStrings(inputs.balanceUsd, inputs.balance),
        // }),
        ...calcInputs,
        auth: props.userAuthWallet,
        cs: sha256(
          props.userAuthWallet + process.env.REACT_APP_SECRET
        ).toString(),
      }).then((res) => {
        if (res.data?.status == 200) {
          toast.success("Manually entered vault data has been added.");
          // setDataSaved(true); // return <Redirect to={"/charts/" + assetId} />; // is not working
        } else {
          console.log("res", res.data);
          toast.error(
            "Error adding vault data. " + process.env.REACT_APP_STR_TRY_AGAIN,
            {
              autoClose: 10000,
            }
          );
        }
      });
  };

  function commaSum(field) {
    return field.split(",").reduce((prevSum, cur) => prevSum + +cur, 0);
  }
  function rewardsUsd(inputs_ = inputs) {
    return inputs_.rewardUsd
      ? commaSum(inputs_.rewardUsd) // +inputs_.rewardUsd
      : inputs_.reward * inputs_.rewardTokensUsd;
  }

  return dataSaved ? (
    <Redirect to={"/charts/" + assetId} />
  ) : (
    <div className="page addRow addBalRwdPage">
      {/* <label>Wallet:</label>
      <input
        type="text"
        placeholder="0xAfbE5E703B47Aa57F75a5Dd805651eBA13ea135F"
        onChange={(event) => setWallet(event.target.value)}
      /> */}
      <label className="required">Wallet:</label>
      <select
        className="required"
        name="wallet"
        value={inputs.wallet}
        onChange={inputChange}
      >
        {props.userWallets.map((val, key) => {
          return (
            <option key={val.wallet} value={val.wallet}>
              {val.wallet}
            </option>
          );
        })}
      </select>

      {/* <label>Id:</label>
      <input
        type="number"
        placeholder="801"
        onChange={(event) => setId(event.target.value)}
      /> */}
      {assetId ? (
        <div className="vaultData">
          <label>Vault:</label>{" "}
          <b>
            {assetId +
              ":" +
              vaultData[0]?.Blockchain +
              vaultData[0]?.Platform +
              vaultData[0]?.Uses +
              vaultData[0]?.Vault}
          </b>
        </div>
      ) : (
        <>
          <h2>Vault</h2>
          <label>Blockchain:</label>
          <input
            name="blockchain"
            type="text"
            placeholder="Solana"
            onChange={inputChange}
          />
          <label className="header">Vault Id:Name:</label>
          <input
            type="text"
            placeholder="801:SolanaSaberwUST-USDC"
            onChange={(event) => setName(event.target.value)}
          />
        </>
      )}

      <VaultItem
        title="Balance"
        token="lpToken"
        data={[
          { name: "balance", placeholder: 592.8448 },
          { name: "balanceUsd", placeholder: 596.41 },
          { name: "lpTokensUsd", placeholder: 0.994 },
        ]}
        inputs={inputs}
        inputChange={inputChange}
      />

      {/* <h2>Rewards</h2>
      <label className="header">Reward, {inputs.rewardToken}:</label>
      <input
        name="reward"
        type="text"
        placeholder="28.518"
        onChange={inputChange}
      />
      <Inpt
        label="Reward, $"
        name="rewardUsd"
        val={inputs.rewardUsd}
        type="text"
        placeholder="2.1298"
        onChg={inputChange}
      />
      <Inpt
        label={inputs.rewardToken + "/$"}
        name="rewardTokensUsd"
        val={inputs.rewardTokensUsd}
        type="text"
        placeholder=""
        onChg={inputChange}
      /> */}
      <HiddenBlock title="Rewards">
        <VaultItem
          title="Rewards"
          token="rewardToken"
          data={[
            { name: "reward", placeholder: 28.518 },
            { name: "rewardUsd", placeholder: 2.1298 },
            { name: "rewardTokensUsd", placeholder: 13.3899 },
          ]}
          inputs={inputs}
          inputChange={inputChange}
        />
      </HiddenBlock>

      <HiddenBlock title="Borrowed">
        <VaultItemNumerous
          title="Borrowed 1"
          token=""
          data={[
            { name: "borrowedAbbr", placeholder: inputs.lpToken.split("-")[0] },
            { name: "borrowed", placeholder: 28.518 },
            { name: "borrowedUsd", placeholder: 2.1298 },
            { name: "borrowedTokensUsd", placeholder: 13.3899 },
          ]}
          inputs={inputs}
          inputChange={inputChange}
        />

        <HiddenBlock title="Borrowed 2">
          <VaultItemNumerous
            title="Borrowed 2"
            showTitle={false}
            token=""
            data={[
              {
                name: "borrowedAbbr2",
                placeholder: inputs.lpToken.split("-")[1],
              },
              { name: "borrowed2", placeholder: 28.518 },
              { name: "borrowedUsd2", placeholder: 2.1298 },
              { name: "borrowedTokensUsd2", placeholder: 13.3899 },
            ]}
            inputs={inputs}
            inputChange={inputChange}
          />

          {(inputs.borrowed && inputs.borrowed2) ||
          (inputs.borrowedUsd && inputs.borrowedUsd2) ? (
            <h2>Total Borrowed</h2>
          ) : (
            ""
          )}
          {inputs.borrowed && inputs.borrowed2 ? (
            <label>
              Total Borrowed: {inputs.borrowedAbbr} {inputs.borrowed} +{" "}
              {inputs.borrowedAbbr2} {inputs.borrowed2}
            </label>
          ) : (
            ""
          )}
          {inputs.borrowedUsd && inputs.borrowedUsd2 ? (
            <label>
              Total Borrowed, $:{" "}
              {+(+inputs.borrowedUsd + +inputs.borrowedUsd2).toFixed(4)}
            </label>
          ) : (
            ""
          )}
        </HiddenBlock>
      </HiddenBlock>

      <h2>Total</h2>

      {
        // inputs.balanceUsd && rewardsUsd() ? (
        calcInputs.totalUsd ? (
          <div className="calcField">
            <label>Balance + Rewards, $: </label>
            {calcInputs.totalUsd}
            {/* {+(+inputs.balanceUsd + rewardsUsd()).toFixed(2)} */}
          </div>
        ) : (
          <Inpt
            label="Total (Balance + Rewards), $"
            name="totalUsd"
            val={inputs.totalUsd}
            type="text"
            placeholder="598.1298"
            onChg={inputChange}
            className="header"
          />
        )
      }

      {
        // inputs.balanceUsd && rewardsUsd() && inputs.borrowedUsd ? (
        calcInputs.totalUsd && calcInputs.borrowedUsd ? (
          <div className="calcField">
            <label>Balance + Rewards - Borrowed, $: </label>
            {
              +(calcInputs.totalUsd - +calcInputs.borrowedUsd) //- +inputs.borrowedUsd2
                .toFixed(2)
            }
          </div>
        ) : (
          ""
        )
      }

      <HiddenBlock title="Vault Announced APR, APY, TVL">
        <Inpt
          label="APR"
          name="apr"
          val={inputs.apr}
          type="text"
          placeholder="1.7"
          onChg={inputChange}
        />
        {inputs.apr ? (
          <div className="dprBlock">
            <div className="calcField small">
              <label>DailyPR, %: </label>
              {+(inputs.apr / 365).toFixed(4)}
            </div>
            <div className="calcField small">
              <label>WeeklyPR, %: </label>
              {+(inputs.apr / 52).toFixed(4)}
            </div>
            <div className="calcField small">
              <label>MonthlyPR, %: </label>
              {+(inputs.apr / 12).toFixed(4)}
            </div>
          </div>
        ) : (
          ""
        )}
        <Inpt
          label="APY"
          name="apy"
          val={inputs.apy}
          type="text"
          placeholder="11.759"
          onChg={inputChange}
        />
        <Inpt
          label="TVL"
          name="tvl"
          val={inputs.tvl}
          type="text"
          placeholder="18803970"
          onChg={inputChange}
        />

        {/* <h2>Remarks</h2> */}
      </HiddenBlock>

      <HiddenBlock title="Borrow">
        <Inpt
          label={"Borrow, " + inputs.lpToken}
          name="borrow"
          val={inputs.borrow}
          type="text"
          placeholder=""
          onChg={inputChange}
        />
        {/* <label>Total Borrowed, {inputs.lpToken}: 112.365</label> */}

        <Inpt
          label="Borrowed, $"
          name="borrowUsd"
          val={inputs.borrow}
          type="text"
          placeholder=""
          onChg={inputChange}
        />
        {/* <label>Total Borrowed, $: 12.5</label> */}
      </HiddenBlock>

      {/* Claimed */}

      <HiddenBlock title="Claim Rewards">
        <ClaimRewardsVaultItem
          inputs={inputs}
          setInputs={setInputs}
          setCalcInputs={setCalcInputs}
        />
      </HiddenBlock>

      {/* Remark & Time */}

      <Inpt
        label="Remark"
        name="remark"
        val={inputs.remark}
        type="text"
        placeholder="Claimed SBR @ 0.015520613 SOL"
        onChg={inputChange}
      />

      <Inpt
        label="Time"
        name="time"
        val={inputs.time}
        type="text"
        placeholder=""
        onChg={inputChange}
      />

      {/* <button className="add" onClick={displayInfo}>
        Add
      </button> */}
      <Button
        variant="contained"
        className="add"
        endIcon={<AddBox />}
        onClick={saveInfo}
      >
        Add balances for {walletShortLast(inputs.wallet)}
      </Button>
    </div>
  );
}

{
  /* <label>Platform:</label>
      <input
        name="platform"
        type="text"
        placeholder="Saber"
        onChange={inputChange}
      />

      <label>Vault:</label>
      <input
        name="vault"
        type="text"
        placeholder="wUST-USDC"
        onChange={inputChange}
      />

      <label>Uses:</label>
      <input
        name="uses"
        type="text"
        placeholder="Sushi"
        onChange={inputChange}
      />

      <label>BalanceOf:</label>
      <input
        name="balanceOf"
        type="text"
        placeholder="592.8448"
        onChange={inputChange}
      /> */
}
{
  /* <label>PricePerFullShare:</label>
      <input
        name="pricePerFullShare"
        type="text"
        placeholder="1"
        onChange={inputChange}
      /> */
}

{
  /* <label>RewardToken:</label>
      <input
        name="rewardToken"
        type="text"
        placeholder="SBR"
        onChange={inputChange}
      /> */
}
{
  /* <label>LpTokens:</label>
      <input
        type="text"
        placeholder="0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23,0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6"
      /> */
}
{
  /* <Inpt
        label="LpTokens"
        name="lpTokens"
        val={inputs.lpTokens}
        type="text"
        placeholder="0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23,0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6"
        onChg={inputChange}
      /> */
}
